module.exports = __webpack_public_path__ + "media/images/game/who_can_join/who-c1c224a8cd04e154477a9d539a4aa543.png";